import { render, staticRenderFns } from "./EduRecContentClick.vue?vue&type=template&id=7f1c1291&scoped=true"
import script from "./EduRecContentClick.vue?vue&type=script&lang=js"
export * from "./EduRecContentClick.vue?vue&type=script&lang=js"
import style0 from "./EduRecContentClick.vue?vue&type=style&index=0&id=7f1c1291&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1c1291",
  null
  
)

export default component.exports